import React from 'react';

// component to be displayed if a non existing route is selected
const NotFound = () => {
    return (<h1>NotFound</h1>);
}

export default NotFound;